import React, { memo, useContext } from "react";
import { ToolFnContext } from "./utils/context";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

const IMAGE_ELEM_WIDTH = 314;

export default memo(
  ({
    data,
    isStreaming,
  }: {
    data: IMultiElementCombineMsg.IImageElem;
    isStreaming: boolean;
  }) => {
    const { url, preview, height = 1, width = 2 } = data;
    const { previewImg } = useContext(ToolFnContext);
    const style = getDefaultComponentStyle(data);

    // 确保 height 和 width 是有效的数字
    const validHeight = Number.isFinite(height) ? height : 1;
    const validWidth = Number.isFinite(width) ? width : 2;

    // 防止除以零
    const aspectRatio = validWidth > 0 ? validHeight / validWidth : 1;

    const openImage = (e: any) => {
      if (!preview || !previewImg) return;
      e.stopPropagation();
      try {
        previewImg(url);
      } catch (error) {}
    };
    return (
      <div className={"sscard-imgBox"} style={style}>
        <img
          className={`${"image"} ${preview ? "preview" : ""} ${
            isStreaming ? "sscard-disableAction" : ""
          }`}
          style={{ height: IMAGE_ELEM_WIDTH * aspectRatio }}
          src={`${url}?imageMogr2/ignore-error/1/auto-orient`}
          onClick={openImage}
        />
      </div>
    );
  }
);
